export function formatDate(isoString: string): string {
    const date = new Date(isoString)
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }
    return date.toLocaleDateString('en-US', options)
}

export function formatTime(isoString: string): string {
    const date = new Date(isoString)

    let hours: number = date.getHours()
    const minutes: number = date.getMinutes()
    const ampm: string = hours >= 12 ? 'PM' : 'AM'

    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'

    const formattedMinutes: string =
        minutes < 10 ? '0' + minutes : minutes.toString()

    return `${hours}:${formattedMinutes} ${ampm}`
}
